import { createI18n } from 'vue-i18n';
import { watch } from 'vue';

import en from '@/js/json/lang/en.json';
import fr from '@/js/json/lang/fr.json';
import nl from '@/js/json/lang/nl.json';

const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: window.location.pathname.split('/')[1] || 'fr',
    fallbackLocale: 'en',
    messages: {
        fr,
        en,
        nl,
    },
    availableLocales: ['fr', 'en', 'nl'],
    warnHtmlMessage: false,
    runtimeOnly: false,
    compositionOnly: false,
    fullInstall: true,
});

// Watch for locale changes and emit custom event
let previousLocale = i18n.global.locale.value;

// Use Vue's watch function to detect locale changes
const unwatchLocale = watch(
    () => i18n.global.locale.value,
    newLocale => {
        if (newLocale !== previousLocale) {
            // Emit custom event
            window.dispatchEvent(
                new CustomEvent('localeChanged', {
                    detail: {
                        locale: newLocale,
                        previousLocale: previousLocale,
                    },
                }),
            );

            // Update localStorage for persistence
            localStorage.setItem('app_locale', newLocale);

            // Update HTML lang attribute
            document.documentElement.lang = newLocale;

            previousLocale = newLocale;
        }
    },
    { immediate: false },
);

// Store the unwatch function for cleanup if needed
i18n.unwatchLocale = unwatchLocale;

export default i18n;
